import { useState } from "react";
import { Copy, Check, Code2 } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "../components/ui/dialog";

const Icon = ({ path, viewBox = "0 0 24 24" }) => (
  <svg viewBox={viewBox} className="h-6 w-6" fill="currentColor"><path d={path} /></svg>
);

const PLATFORMS = [
  {
    key: "gmail", label: "Gmail", color: "#EA4335", mode: "intent",
    path: "M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.909 1.528-1.145C21.69 2.28 24 3.434 24 5.457z",
    href: (u, t) => `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(t)}&body=${encodeURIComponent(t + "\n\n" + u)}`,
  },
  {
    key: "tiktok", label: "TikTok", color: "#000", mode: "copy",
    path: "M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.08-.14 1.62.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
    site: "https://www.tiktok.com/upload",
  },
  {
    key: "instagram", label: "Instagram", color: "#E4405F", mode: "copy",
    path: "M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 2.76a5.46 5.46 0 1 0 0 10.92 5.46 5.46 0 0 0 0-10.92Zm0 9a3.54 3.54 0 1 1 0-7.08 3.54 3.54 0 0 1 0 7.08Zm6.95-9.22a1.28 1.28 0 1 1-2.55 0 1.28 1.28 0 0 1 2.55 0Z",
    site: "https://www.instagram.com",
  },
  {
    key: "fb", label: "Facebook", color: "#1877F2", mode: "intent",
    path: "M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07c0 6.02 4.39 11.01 10.13 11.93v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.08 24 18.09 24 12.07Z",
    href: (u) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}`,
  },
  {
    key: "youtube", label: "YouTube", color: "#FF0000", mode: "copy",
    path: "M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.51A3.02 3.02 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.12 2.14c1.88.51 9.38.51 9.38.51s7.5 0 9.38-.51a3.02 3.02 0 0 0 2.12-2.14A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8ZM9.55 15.57V8.43L15.82 12l-6.27 3.57Z",
    site: "https://studio.youtube.com",
  },
  {
    key: "x", label: "X", color: "#000", mode: "intent",
    path: "M18.9 1.2h3.7l-8 9.2L24 22.8h-7.4l-5.8-7.6-6.6 7.6H.5l8.6-9.8L0 1.2h7.6l5.2 6.9 6.1-6.9Zm-1.3 19.4h2L6.5 3.3H4.3l13.3 17.3Z",
    href: (u, t) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(t)}&url=${encodeURIComponent(u)}`,
  },
  {
    key: "wa", label: "WhatsApp", color: "#25D366", mode: "intent",
    path: "M.06 24l1.68-6.13A11.86 11.86 0 0 1 .16 11.9C.16 5.34 5.5.0 12.07.0a11.82 11.82 0 0 1 8.41 3.49 11.82 11.82 0 0 1 3.48 8.41c0 6.56-5.34 11.9-11.9 11.9a11.9 11.9 0 0 1-5.69-1.45L.06 24Zm6.6-3.8c1.68.99 3.28 1.58 5.4 1.58 5.45 0 9.9-4.43 9.9-9.88a9.85 9.85 0 0 0-2.9-7A9.84 9.84 0 0 0 12.07 2c-5.46 0-9.9 4.43-9.9 9.88 0 2.23.65 3.9 1.74 5.65l-.99 3.62 3.74-.95Zm11.4-5.5c-.07-.12-.27-.2-.57-.35-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.76-1.64-2.05-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.2 3.07.15.2 2.1 3.2 5.07 4.49.71.3 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.42.25-.7.25-1.29.17-1.42Z",
    href: (u, t) => `https://wa.me/?text=${encodeURIComponent(t + " " + u)}`,
  },
  {
    key: "tg", label: "Telegram", color: "#229ED9", mode: "intent",
    path: "M11.94 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm5.55 8.16-1.86 8.78c-.14.62-.5.77-1.02.48l-2.82-2.08-1.36 1.31c-.15.15-.28.28-.57.28l.2-2.87 5.23-4.73c.23-.2-.05-.31-.35-.11l-6.46 4.07-2.78-.87c-.6-.19-.62-.6.13-.9l10.86-4.19c.5-.18.94.12.77.86Z",
    href: (u, t) => `https://t.me/share/url?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
  },
];

export const ShareMenu = ({ open, onOpenChange, video }) => {
  const [copied, setCopied] = useState(false);
  const [copiedEmbed, setCopiedEmbed] = useState(false);
  if (!video) return null;

  const url = `${window.location.origin}/watch/${video.id}`;
  const text = `${video.title} by ${video.artist_name} on NEXTtt`;
  const embed = `<iframe src="${url}" width="324" height="576" frameborder="0" allow="autoplay; fullscreen" title="${video.title}"></iframe>`;

  const copy = (val, setter) => {
    navigator.clipboard.writeText(val);
    setter(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setter(false), 1800);
  };

  const openShare = (p) => {
    if (p.mode === "copy") {
      navigator.clipboard.writeText(url);
      toast.success(`Link copied — paste it into your ${p.label} post`);
      window.open(p.site, "_blank", "noopener,noreferrer");
    } else {
      window.open(p.href(url, text), "_blank", "noopener,noreferrer,width=600,height=600");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-950 border-white/10 text-white rounded-none max-w-md" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold tracking-tight">Share this video</DialogTitle>
          <DialogDescription className="text-zinc-400 text-sm">Send this track to Gmail, TikTok, Instagram, Facebook, YouTube and more.</DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-4 gap-3 mt-2">
          {PLATFORMS.map((p) => (
            <button
              key={p.key}
              data-testid={`share-${p.key}`}
              onClick={() => openShare(p)}
              className="flex flex-col items-center gap-2 group"
            >
              <span
                className="h-12 w-12 rounded-full flex items-center justify-center text-white transition-transform group-hover:scale-110"
                style={{ background: p.color }}
              >
                <Icon path={p.path} />
              </span>
              <span className="text-[11px] text-zinc-400">{p.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-4">
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-2">Video link</p>
          <div className="flex items-center gap-2 bg-zinc-900 border border-white/10 p-1">
            <span className="flex-1 truncate text-sm text-zinc-300 px-2" data-testid="share-link">{url}</span>
            <button
              data-testid="copy-link-button"
              onClick={() => copy(url, setCopied)}
              className="flex items-center gap-1.5 bg-[#FFD60A] text-black px-3 py-2 text-sm font-semibold hover:bg-[#FFD60A]/90 transition-colors"
            >
              {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
              {copied ? "Copied" : "Copy"}
            </button>
          </div>
        </div>

        <div className="mt-3">
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-2 flex items-center gap-2">
            <Code2 className="h-4 w-4" /> Embed
          </p>
          <div className="flex items-center gap-2 bg-zinc-900 border border-white/10 p-1">
            <span className="flex-1 truncate text-xs text-zinc-400 px-2 font-mono">{embed}</span>
            <button
              data-testid="copy-embed-button"
              onClick={() => copy(embed, setCopiedEmbed)}
              className="bg-white/10 text-white px-3 py-2 text-sm font-semibold hover:bg-white/20 transition-colors"
            >
              {copiedEmbed ? "Copied" : "Copy"}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
